<template>
  <Fragment>
    <template v-if="$route.name !== 'role'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>角色名称：</span>
              <el-input v-model="roleName"> </el-input>
            </div>
            <el-button type="primary" class="ml-20" @click="searchRoleInfo"
              >查询</el-button
            >
          </div>
          <el-button type="primary" class="mr-20" @click="addRole"
            >添加角色</el-button
          >
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色名称" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.roleName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="角色描述" width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.description }}</span>
          </template>
        </el-table-column>
        <el-table-column label="添加时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" :fit="true">
          <template slot-scope="scope">
            <el-button size="mini" @click="editRoleInfo(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteRole()"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      roleName: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getRoleList() {
      let _this = this;
      let param = {
        url: "/api/role/getRoleList",
        params: {
          roleName: _this.roleName,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getRoleList", param).then(() => {
        _this.list = _this.$store.state.system.roles.list;
        _this.total = _this.$store.state.system.roles.total;
      });
    },
    //查询
    searchRoleInfo() {
      let _this = this;
      _this.getRoleList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getRoleList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getRoleList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getRoleList();
    },
    //删除角色
    deleteRole() {
      let _this = this;
      _this.$message({
        type: "warning",
        message: "不支持删除角色,请新建角色并做相应权限控制!",
        duration: 3000
      });
    },
    //编辑
    editRoleInfo(row) {
      this.$router.push({
        name: "roleManage",
        params: { id: row.id }
      });
    },
    //添加角色
    addRole() {
      this.$router.push({
        name: "addRole"
      });
    }
  },
  created() {
    let _this = this;
    _this.getRoleList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
